import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import api from "../../app/api";
import baseURL from "../../app/utils.js";
import { errorSnack } from "../snackbar/snackbarSlice";

export const fetchPromoPageProducts = createAsyncThunk(
  "promoPage/fetchPromoPageProducts",
  async (args, thunkAPI) => {
    try {
      const config = {
        headers: {
          "X-Client-Host": window.location.hostname,
        },
      };
      if (args.token) {
        config.headers.Authorization = `Bearer ${args.token}`;
      }
      const response = await api.get(
        `${baseURL}/v1/contents/promo_page_data`,
        config
      );
      return await response.data;
    } catch (error) {
      if (error.response && error.response.data) {
        thunkAPI.dispatch(
          errorSnack(
            error.response.data.error_description ||
              "Error fetching promo page products"
          )
        );
      }
      return thunkAPI.rejectWithValue({ error: error.message });
    }
  }
);

const promoPageSlice = createSlice({
  name: "promoPage",
  initialState: {
    products: [],
    loading: "idle",
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchPromoPageProducts.pending, (state) => {
        state.loading = "loading";
        state.error = null;
      })
      .addCase(fetchPromoPageProducts.fulfilled, (state, action) => {
        state.products = action.payload;
        state.loading = "succeeded";
      })
      .addCase(fetchPromoPageProducts.rejected, (state, action) => {
        state.loading = "failed";
        state.error = action.payload?.error || action.error.message;
      });
  },
});

export const selectPromoPageProducts = (state) => state.promoPage.products;
export const selectPromoPageLoading = (state) => state.promoPage.loading;

export default promoPageSlice.reducer;
